import api from "../../client";
import { AccountDetailResponseData } from "../../types/account";

export const accountRequest = async (uuid: string | undefined) => {
  const { data } = await api.get<AccountDetailResponseData>(`/account/${uuid}`);

  return data;
};
